import {Injectable} from '@angular/core';
import {BaseRequestOptions, Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import { VTotauxFormationsAvisAdmission } from '../candidature';
import {Formation} from './formation.model';

@Injectable()
export class FormationService {

    private resourceUrl = 'api/formations';
    private formationsCampagneUrl = 'api/formationsCampagne';
    private resourceNewFormationUrl = 'api/newFormationsComposants';
    private disciplinesFormationsUrl = 'api/formationsDisciplines';
    private servicesFormationsUrl = 'api/formationServices';
    private autresFormationsUrl = 'api/formationsAutres';


    private static createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            if (req.mentionId) {
                params.set('mentionId', req.mentionId);
            }
            if (req.parcoursId) {
                params.set('parcoursId', req.parcoursId);
            }
            if (req.niveauId) {
                params.set('niveauId', req.niveauId);
            }
            if (req.disciplineId) {
                params.set('disciplineId', req.disciplineId);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }

    constructor(private http: Http) { }

    create(formation: Formation): Observable<Formation> {
        let copy: Formation = Object.assign({}, formation);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(formation: Formation): Observable<Formation> {
        // On modifie les données dépendantes pour plus de cohérence
        if(formation.lc === false) {
            formation.rang = false;
            //formation.totalLc=0;
        }
        if(formation.rang === false) {
            formation.affichageRang = false;
            formation.rangAuto = false;
        }
        if(formation.rangAuto === false) {
            formation.surbooking = false;
        }
        if(formation.surbooking === false) {
            formation.nbPlacesSurbooking = 0;
            formation.nbDesistementsSurbooking = 0;
        }
        let copy: Formation = Object.assign({}, formation);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    updateService(formations: Formation[], serviceId): Observable<Formation[]> {
        let copy: Formation[] = formations.splice(0);
        copy.forEach(formation => {
            formation.serviceId = serviceId;
        });
        return this.http.put(this.servicesFormationsUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Formation> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return res.json();
        });
    }

    findPourEtudiant(id: number, etudiantId: number): Observable<Formation> {
        return this.http.get(`${this.resourceUrl}/${id}/${etudiantId}`).map((res: Response) => {
            return res.json();
        });
    }

    findFormationCampagne(idCampagne: number): Observable<Formation[]> {
        return this.http.get(`${this.formationsCampagneUrl}/${idCampagne}`).map((res: Response) => {
            return res.json();
        });
    }
    getAllVTotauxFormationsAvisAdmission(): Observable<VTotauxFormationsAvisAdmission[]> {
        return this.http.get(`/api/totaux-formations-avis-admission`).map((res: Response) => {
            return res.json();
        });
    }
    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req && req.campagneId) {
            params.set('campagneId', req.campagneId);
        }
        if (req && req.pasCampagneId) {
            params.set('pasCampagneId', req.pasCampagneId);
        }
        if (req && req.mentionId) {
            params.set('mentionId', req.mentionId);
        }
        if (req && req.disciplineId) {
            params.set('disciplineId', req.disciplineId);
        }
        if (req && req.parcoursId) {
            params.set('parcoursId', req.parcoursId);
        }
        if (req && req.niveauId) {
            params.set('niveauId', req.niveauId);
        }
        if (req && req.userId) {
            params.set('userId', req.userId);
        }
        if (req && req.supprimee) {
            params.set('supprimee', req.supprimee);
        } else {
            params.set('supprimee', false.toString());
        }
        if (req && req.ids) {
            params.set('ids', req.ids);
        }
        return this.http.get(this.resourceUrl, { search: params });
    }

    queryDisciplinesFormations(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.niveau) {
            params.set('niveau', req.niveau);
        }
        if (req.reinscription != null) {
            params.set('reinscription', req.reinscription);
        }
        if (req.userId != null) {
            params.set('userId', req.userId);
        }
        if (req.lecture != null) {
            params.set('lecture', req.lecture);
        }
        return this.http.get(this.disciplinesFormationsUrl, { search: params });
    }

    queryNewFormationsComposant(req?: any): Observable<Response> {
        let options = FormationService.createRequestOption(req);
        return this.http.get(this.resourceNewFormationUrl, options);
    }

    queryAutresFormations(req?: any): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        if (req.reinscription != null) {
            params.set('reinscription', req.reinscription);
        }
        if (req.lecture != null) {
            params.set('lecture', req.lecture);
        }
        return this.http.get(this.autresFormationsUrl, { search: params });
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/formation.service.ts